import { useMemo } from 'react';

import {
  usePrintsUiStore,
  usePrintsOrderStore,
  usePrintsConfigStore,
} from '../stores';
import {
  selectSizesWithPhotos,
  selectSizesByFinish,
} from '../stores/selectors';

// Hook to provide sizesWithPhotos by co-ordinating store selectors.
// When `filterToSelectedFinish` is true (default), it returns sizes
// filtered by the currently selected finish. When false, it returns
// all available sizes that have associated photos, without filtering
// by finish.
export const useSizesWithPhotos = (filterToSelectedFinish = true) => {
  const photos = usePrintsOrderStore((state) => state.photos);
  const allSizes = usePrintsConfigStore((state) => state.allSizes);
  const selectedFinishName = usePrintsUiStore(
    (state) => state.selectedFinishName,
  );

  return useMemo(() => {
    const sizesWithPhotos = selectSizesWithPhotos(allSizes, photos);
    if (!filterToSelectedFinish) {
      return sizesWithPhotos;
    }
    return selectSizesByFinish(sizesWithPhotos, selectedFinishName);
  }, [allSizes, photos, selectedFinishName, filterToSelectedFinish]);
};
